




import Vue from 'vue';
import _ from 'lodash';

export default Vue.extend({
  props: {
    value: [String, Number],
  },
  computed: {
    formattedValue(): string {
      return this.format(this.value);
    },
  },
  methods: {
    format(cents) {
      if (_.isNil(cents) || cents === '') return cents;
      return (cents / 100).toFixed(2);
    },
    toCents(amount) {
      if (amount === '') {
        this.$emit('input', null);
      } else {
        const cents = amount * 100;
        this.$emit('input', cents);
      }
    },
  },
});
